export default class BarGui {
    private mBar: Phaser.GameObjects.Graphics;
    private mLabel: Phaser.GameObjects.Text;
    public X = 0;
    public Y = 0;
    public Width: number = 80;
    public Height: number = 16;

    public HighColor: number = 0x6EE500;
    public LowColor: number = 0xBC2200;
    public LowColorThreshold: number = 30;

    private mValue = 0;
    private mMaxValue = 0;
    private mPercentage = 0;

    constructor(scene: Phaser.Scene, x: number, y: number, totalValue: number) {
        this.mBar = new Phaser.GameObjects.Graphics(scene);
        this.X = x;
        this.Y = y;
        this.mValue = totalValue;
        this.mMaxValue = totalValue;
        this.mPercentage = 76 / this.mValue;
        this.Draw();
        scene.add.existing(this.mBar);

        this.mLabel = scene.add.text(
            x + this.Width / 2,
            y + this.Height / 2,
            `${Math.ceil(totalValue)}/${totalValue}`,
            {
                fontFamily: "monospace",
                fontSize: "10px",
                color: "#ffffff",
                stroke: "#000000",
                strokeThickness: 2,
            }
        ).setOrigin(0.5, 0.5);
    }

    public SetPosition(vector: Phaser.Math.Vector2) {
        this.X = vector.x;
        this.Y = vector.y;
    }

    public Update(amount, maxAmount) {
        this.mValue = amount;
        this.mMaxValue = maxAmount;
        this.mPercentage = (this.Width - 4) / maxAmount;

        if (this.mValue < 0) {
            this.mValue = 0;
        }
        this.Draw();
    }

    public Decrease(amount) {
        this.mValue -= amount;

        if (this.mValue < 0) {
            this.mValue = 0;
        }

        this.Draw();

        return (this.mValue === 0);
    }

    public Draw() {
        this.mBar.clear();

        //  BG
        this.mBar.fillStyle(0x000000);
        this.mBar.fillRect(this.X, this.Y, this.Width, this.Height);

        //  Health
        this.mBar.fillStyle(0xffffff);
        this.mBar.fillRect(this.X + 2, this.Y + 2, this.Width - 4, this.Height - 4);

        if (this.mValue < this.LowColorThreshold) {
            this.mBar.fillStyle(this.LowColor);
        }
        else {
            this.mBar.fillStyle(this.HighColor);
        }

        var d = Math.floor(this.mPercentage * this.mValue);

        this.mBar.fillRect(this.X + 2, this.Y + 2, d, this.Height - 4);

        if (this.mLabel) {
            this.mLabel.setPosition(this.X + this.Width / 2, this.Y + this.Height / 2);
            this.mLabel.setText(`${Math.ceil(this.mValue)}/${this.mMaxValue}`);
        }
    }

    public Clear(){
        this.mBar.clear();
    }

    public Destroy() {
        this.mBar.destroy();
        this.mLabel.destroy();
    }

}
